<stch-calendar-week
  [viewDate]="viewDate"
  [events]="events"
  [calendarType]="CalendarType.DAY"
  [scrollToDate]="scrollToDate()"
  [showDayHeader]="showDayHeader()"
  (dateClicked)="dateClicked.emit($event)"
  (dateDblClicked)="dateDblClicked.emit($event)"
  (eventDropped)="eventDropped.emit($event)"
  (dayNumberClicked)="dayNumberClicked.emit($event)"
  (eventClicked)="eventClicked.emit($event)"
  (eventDblClicked)="eventDblClicked.emit($event)"
/>
